<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import RealEstateCommissionSupportDesktopRow from './RealEstateCommissionSupportDesktopRow.vue';

const props = defineProps({
  rows: { type: Array, default: () => [] },
  tab: { type: String, default: 'para_enviar' },
});

const emit = defineEmits(['open', 'details']);
const { t } = useI18n();
const activeRowId = ref(null);

watch(
  [() => props.rows, () => props.tab],
  () => {
    activeRowId.value = null;
  },
  { immediate: true }
);
</script>

<template>
  <div class="block overflow-x-auto">
    <table
      class="w-full min-w-0 border-collapse text-left font-[Roboto] text-sm"
    >
      <thead
        class="text-sm font-medium leading-6 text-lais-text [&_th]:border-b-[2px] [&_th]:border-[#FFC699] [&_th]:px-[1vw] [&_th]:py-[18px] [&_th]:font-medium"
      >
        <tr class="h-[86px]">
          <th class="w-[79px] min-w-[98px]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.POST_SALE') }}
          </th>
          <th class="w-[90px]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.ENTRY') }}
          </th>
          <th class="w-[92px]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.STORE') }}
          </th>
          <th class="w-[15.7vw]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.ADDRESS') }}
          </th>
          <th class="w-[7vw] max-[1400px]:min-w-[71.984px]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.COMMISSION') }}
          </th>
          <th class="w-[8vw]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.SALE_VALUE') }}
          </th>
          <th class="w-[90px]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.SIGNATURE') }}
          </th>
          <th class="w-[79px]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.MANAGER') }}
          </th>
          <th :class="tab === 'enviadas' ? 'w-[90px]' : 'w-[75px]'">
            {{
              tab === 'enviadas'
                ? t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.SENT_AT')
                : t('REAL_ESTATE_COMMISSION_SUPPORT.TABLE.TYPE')
            }}
          </th>
          <th v-if="tab !== 'enviadas'" class="w-[75px]" />
          <th class="w-[65px]" />
        </tr>
      </thead>
      <tbody>
        <RealEstateCommissionSupportDesktopRow
          v-for="row in rows"
          :key="row.processo_id"
          :row="row"
          :tab="tab"
          :actions-visible="activeRowId === row.processo_id"
          @hover="activeRowId = $event"
          @open="emit('open', $event)"
          @details="emit('details', $event)"
        />
      </tbody>
    </table>
  </div>
</template>
